import React from 'react';
import SectionedList from '../../common/SectionedList/SectionedList';
import { filterableTypesForContext, showNewOption } from '../helpers';

/**
 * @typedef ReportTypeListProps
 * @prop {*=} selectedReportType
 * @prop {*=} setSelectedReportType
 * @prop {*=} setSelectedReport
 * @prop {*=} context
 */
/**
 * @type {React.FC<ReportTypeListProps>}
 */
function ReportTypeList({
  selectedReportType,
  setSelectedReportType,
  setSelectedReport,
  context,
}) {
  const options = [
    {
      title: '',
      value: '',
      key: 'report-view-type-selection',
      children: [
        {
          text: 'All',
          value: 'all',
        },
        {
          text: 'Recents',
          value: 'recents',
        },
        {
          text: 'Favorites',
          value: 'favorites',
        },
        {
          text: 'Created by me',
          value: 'created_by_me',
        },
      ],
    },
  ];

  const filterableTypes = filterableTypesForContext(context);

  if (filterableTypes.length > 0) {
    options.push({
      // @ts-expect-error options type is inferred from the previous element, so it thinks it SHOULD be a string
      title: <hr />,
      key: 'report-type-selection',
      children: filterableTypes.map(item => {
        if (context !== 'idea portal section') {
          item.new = showNewOption(item.value);
        }
        return item;
      }),
    });
  }

  return (
    <SectionedList
      options={options}
      selected={selectedReportType}
      onClick={item => {
        setSelectedReportType(item.value);
        setSelectedReport(null);
      }}
    />
  );
}

export default ReportTypeList;
